(function () {
  'use strict';
  var bootstrap;
  function loadScript() {
    if (window.Trustpilot) return Promise.resolve();
    if (bootstrap) return bootstrap;
    bootstrap = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      var timeout = setTimeout(function () { script.remove(); bootstrap = null; reject(new Error('Trustpilot timeout')); }, 15000);
      script.onload = function () { clearTimeout(timeout); resolve(); };
      script.onerror = function () { clearTimeout(timeout); script.remove(); bootstrap = null; reject(new Error('Trustpilot unavailable')); };
      document.head.appendChild(script);
    });
    return bootstrap;
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-load-trustpilot]');
    if (!button) return;
    var section = button.closest('#ProductReviews');
    var container = section.querySelector('[data-trustpilot-container]');
    var widget = section.querySelector('[data-trustpilot-widget]');
    button.disabled = true;
    loadScript().then(function () {
      if (!window.Trustpilot || !window.Trustpilot.loadFromElement) throw new Error('Missing widget API');
      container.hidden = false;
      window.Trustpilot.loadFromElement(widget, true);
      button.hidden = true;
      section.querySelector('[data-trustpilot-status]').hidden = true;
    }).catch(function () {
      button.disabled = false;
      section.querySelector('[data-trustpilot-status]').textContent = widget.dataset.errorText;
    });
  });
})();
